module.exports = __webpack_public_path__ + "img/logo_mypart.8b0a7336.png";